import React, { useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import colors from '../../styles/colors'

import logo from '../../assets/logo.png'
import orangeLogo from '../../assets/orangeLogo.png'
import lemonLogo from '../../assets/lemonLogo.png'
import yogurtLogo from '../../assets/yogurtLogo.png'
import strawberryLogo from '../../assets/strawberryLogo.png'
import dollarLogo from '../../assets/dollarLogo.png'
import arrowLogo from '../../assets/arrowLogo.png'
import swissFlag from '../../assets/swissFlag.png'
import Statistics from './Statistics'

const StyledLogo = styled.div`
    position: relative;
    width: 100%;
    height: 30vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;
`

const animationDelay = 0.9
const animationDuration = 3

const arrowBounce = keyframes`
0% { transform: translateX(0); animation-timing-function: ease-out;}
15% { transform: translateX(-60px);  animation-timing-function: ease-in;}
30% { transform: translateX(0px);  animation-timing-function: ease-out;}
40% { transform: translateX(-20px);  animation-timing-function: ease-in;}
50% { transform: translateX(0px);  animation-timing-function: ease-out;}
55% { transform: translateX(-5px);  animation-timing-function: ease-in;}
60% { transform: translateX(0px);  animation-timing-function: ease-out;}`
const StyledLeftArrowLogo = styled.img`
    position: absolute;
    margin-right: 20vh;
    height: 23vh;
    animation: ${arrowBounce} ${animationDuration}s infinite;
    animation-delay: ${animationDuration - animationDelay}s;
`
const StyledRightArrowLogo = styled.img`
    position: absolute;
    rotate: 180deg;
    margin-left: 20vh;
    height: 23vh;
    animation: ${arrowBounce} ${animationDuration}s infinite;
    animation-delay: ${animationDuration - animationDelay}s;
`

const middleBounce = keyframes`
  0% { transform: translateY(0); animation-timing-function: ease-out;}
  15% { transform: translateY(-70px);  animation-timing-function: ease-in;}
  30% { transform: translateY(0px);  animation-timing-function: ease-out;}
  40% { transform: translateY(-30px);  animation-timing-function: ease-in;}
  50% { transform: translateY(0px);  animation-timing-function: ease-in;}
  55% { transform: translateY(-5px);  animation-timing-function: ease-in;}
  60% { transform: translateY(0px);  animation-timing-function: ease-in;}`
const StyledMiddleLogo = styled.img`
    position: absolute;
    margin-bottom: 21px;
    max-height: 30vh;
    max-width: 20vh;
    animation: ${middleBounce} ${animationDuration}s infinite;
    animation-delay: ${animationDuration}s;
`

const StyledHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const StyledH1 = styled.h1`
    font-size: 80px;
    font-weight: 200;
    color: ${colors.second};
    padding-bottom: 10px;
    img {
        height: 80px;
    }
`

const StyledH2 = styled.h4`
    display: flex;
    align-items: center;
    padding: 5px;
`

const StyledStatistics = styled(Statistics)``

function HomeMain({ className }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const images = [
        orangeLogo,
        dollarLogo,
        lemonLogo,
        dollarLogo,
        yogurtLogo,
        dollarLogo,
        strawberryLogo,
        dollarLogo,
    ]

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length)
        }, animationDuration * 1000)

        return () => clearInterval(interval) // Nettoyer l'intervalle au démontage
    }, [images.length])

    return (
        <div className={className}>
            <StyledHeader>
                <StyledH1>
                    <img src={logo} alt="logo" />
                    &nbsp;Salveat
                </StyledH1>
                <StyledH2>
                    <img
                        src={swissFlag}
                        alt="Swiss flag"
                        style={{ height: '15px' }}
                    />
                    <p>&nbsp;A Swiss Company</p>
                </StyledH2>
            </StyledHeader>
            <StyledLogo>
                <StyledMiddleLogo
                    src={images[currentImageIndex]}
                    alt="Logo website"
                />
                <StyledLeftArrowLogo src={arrowLogo} alt="Logo arrow" />
                <StyledRightArrowLogo src={arrowLogo} alt="Logo arrow" />
            </StyledLogo>
            <StyledStatistics />
        </div>
    )
}

export default HomeMain
